import { Route, Routes, useLocation } from "react-router-dom"
import Coupons from "views/Coupons"
import Menu from "views/Menu"
import MoreMenu from "views/MoreMenu"
import NewsFeed from "views/NewsFeed"
import Order from "views/Order"
import OrderDetails from "views/OrderDetails"
import OrderDone from "views/OrderDone"
import OrderHistoryView from "views/OrderHistoryView"
import BigFishPay from "views/OrderPay/BigFish"
import BigFishBackref from "views/OrderPay/BigFishBackref"
import OfflineBackref from "views/OrderPay/OfflineBackref"
import PayTheOfflineOrder from "views/OrderPay/PayTheOfflineOrder"
import RafiPay from "views/OrderPay/RafiPay"
import SimplePay from "views/OrderPay/SimplePay"
import SimplePayBackref from "views/OrderPay/SimplePayBackref"
import VivaPay from "views/OrderPay/VivaPay"
import VivaPayBackref from "views/OrderPay/VivaPayBackref"
import TeyaPay from "views/OrderPay/Teya"
import OrderPayment from "views/OrderPayment"
import OrderView from "views/OrderView"
import SelectLocation from "views/SelectLocation"
import SelectMenu from "views/SelectMenu"
import SelectTable from "views/SelectTable"
import VIP from "views/Vip"
import Welcome from "views/Welcome"
import ReferalLanding from "views/ReferalLanding"
import Article from "views/Article"
import Locations from "views/Locations"
import Location from "views/Location"
import MapLayouts from "views/MapLayouts"
import TeyaBackref from "views/OrderPay/TeyaBackref"
import VipProfile from "views/VipProfile"
import Achievements from "views/Achievements"
import RafiQvik from "views/OrderPay/RafiQvik"

export default function AppRoutes() {
  const location = useLocation()
  return (
    <Routes location={location} key={location.pathname}>
      <Route path={"/"} exact element={<Welcome />} />
      <Route path={"/home"} exact element={<Welcome />} />
      <Route path={"/menu"} exact element={<Menu />} />
      <Route path={"referal/:id"} element={<ReferalLanding />} />
      <Route path={"order"} element={<Order />} />
      <Route path={"history"} element={<OrderHistoryView />} />
      <Route path={"orderview/:id"} element={<OrderView />} />
      <Route path={"select-location/:uuid"} element={<SelectLocation />} />
      <Route path={"select-menu/:uuid"} element={<SelectMenu />} />
      <Route path={"orderdetails/:id"} element={<OrderDetails />} />
      <Route path={"lastorder"} element={<OrderView lastOrder={true} />} />
      <Route path={"simplepaybackref"} element={<SimplePayBackref />} />
      <Route path={"offlinebackref/:id"} element={<OfflineBackref />} />
      <Route path={"vivapaybackref"} element={<VivaPayBackref />} />
      <Route path={"bigfishbackref"} element={<BigFishBackref />} />
      <Route path={"teyabackref"} element={<TeyaBackref />} />
      <Route path={"orderpayment/:id"} element={<OrderPayment />} />
      <Route path={"orderdone"} element={<OrderDone />} />
      {/* <Route path={"openorders"} element={<OpenOrders />} /> */}
      <Route path={"orderpay"}>
        <Route path={"select/:id"} element={<PayTheOfflineOrder />} />
        <Route path={"simplepay/:id"} element={<SimplePay />} />
        <Route path={"vivasmartcheckout/:id"} element={<VivaPay />} />
        <Route path={"bigfish/:id"} element={<BigFishPay />} />
        <Route path={"teyasecurepay/:id"} element={<TeyaPay />} />
        <Route path={"raiffeisenpay/:id"} element={<RafiPay />} />
        <Route path={"cash/:id"} element={<OrderView />} />
        <Route path={"rafipay/:id"} element={<RafiQvik />} />
      </Route>
      <Route path={"vip"} element={<VIP />} />
      <Route path={"vipProfile"} element={<VipProfile />} />
      <Route path={"achievements"} element={<Achievements />} />

      <Route path={"moremenu"} element={<MoreMenu />} />
      <Route
        path={"selecttable"}
        element={<SelectTable navigateOnSelect={true} />}
      />
      <Route
        path={"c/t/:id"}
        element={<SelectTable navigateOnSelect={true} />}
      />
      <Route path={"newsfeed"}>
        <Route path={"all"} element={<NewsFeed />} />
        <Route path={"all/:id"} element={<NewsFeed />} />
        <Route path={":id"} element={<Article />} />
      </Route>
      <Route path={"coupons"}>
        <Route path={"all"} element={<Coupons />} />
      </Route>
      <Route path={"locations"}>
        <Route path="all" element={<Locations />} />
        <Route path="all/:id" element={<Locations />} />
        <Route path=":id" element={<Location />} />
      </Route>
      <Route path={"map-layouts"}>
        <Route path={"all"} element={<MapLayouts />} />
        <Route path={":id"} element={<MapLayouts />} />
      </Route>
    </Routes>
  )
}
